var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WheelsChocked50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,11c-6.627,0-12,5.373-12,12s5.373,12,12,12s12-5.373,12-12S30.627,11,24,11z M24,30 c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S27.859,30,24,30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,18c-2.757,0-5,2.243-5,5s2.243,5,5,5s5-2.243,5-5S26.757,18,24,18z M24,26c-1.657,0-3-1.343-3-3 s1.343-3,3-3s3,1.343,3,3S25.657,26,24,26z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.936,28H9v7h7.816C14.148,33.399,12.062,30.941,10.936,28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.064,28c-1.127,2.941-3.213,5.399-5.88,7H39v-7H37.064z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WheelsChocked50);
export default __webpack_public_path__ + "static/media/icons8-wheels-chocked-50.7ef8b3bef183caffc46c45bd3e54f28b.svg";
export { ForwardRef as ReactComponent };